module.exports = __webpack_public_path__ + "static/littleWomen7-69bc2992ace221a4d304280c1256b5b7.jpg";